'use client';

import * as React from 'react';
import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from 'next-themes';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  // return <NextThemesProvider {...props}>{children}</NextThemesProvider>
  return (
    <NextThemesProvider
      defaultTheme="light"
      enableSystem={false}
      attribute="class"
      themes={['light']} // только светлая тема
      forcedTheme="light" // принудительно всегда light
    >
      {children}
    </NextThemesProvider>
  );
}
